module.exports = "https://redage.akamaized.net/src/views/player/help/images/pd2.jpg";